import React, { useState, useEffect } from "react";
import { Grid, Container } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import CustomButton from "../../components/Custom/CustomButton";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useFormValidation from "../../components/Custom/FormValidation";
import { buyerRequirementValidationSchema } from "../../components/Custom/ValidationSchema";
const validationSchema = buyerRequirementValidationSchema();
import { requirementsBuyer } from "../../Data/fieldData";
import CustomTextField from "../../components/Custom/CustomTextField";
import { useAlert } from "../../components/Alert";
import LoaderContainer from "../../components/LoaderContainer";
import SubmittingPopup from "../../components/Custom/FormSubmitPopup";
import { CustomTitle } from "../../components/Custom/CustomTypography";

export default function AddRequirement() {
  const [formData, setFormData] = useState({});
  const { t } = useTranslation();
  const [isEdit, setIsEdit] = useState(false);
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const requirementId = searchParams.get("requirementId");

  const { showAlert } = useAlert();
  const { errors, validate } = useFormValidation(formData, validationSchema);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [commodities, setCommodities] = useState([]);

  const fetchCommodityList = async () => {
    try {
      const response = await api.get("/common/commodities/");
      setCommodities(response.data);
    } catch (error) {
      console.log("Error Fetching Commodities list:", error);
    }
  };

  useEffect(() => {
    fetchCommodityList();
    fetchRequirementDetails();
    setLoading(false);
  }, []);

  const postRequirement = () => {
    validate(formData);
    if (Object.keys(errors).length === 0) {
      setSubmitting(true);
      const updatedFormData = formData;

      const apiRequest = isEdit
        ? api.patch(`/buyer/requirements/${requirementId}/`, updatedFormData)
        : api.post("/buyer/requirements/", updatedFormData);

      apiRequest
        .then((response) => {
          if (response && response.data) {
            showAlert(
              "success",
              isEdit ? "Updated Successfully" : "Requirement Added Successfully"
            );
            setSubmitting(false);
            setTimeout(() => {
              navigate("/");
            }, 1500);
          }
        })
        .catch((error) => {
          console.error("Error during posting requirement:", error);
          setSubmitting(false);
          showAlert("error", "Error during posting requirement");
        });
    } else {
      showAlert(
        "warning",
        "Please fix the validation errors before submitting."
      );
    }
  };

  const handleChange = (name, value) => {
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    console.log(formData);
    validate({ ...formData, [name]: value });
  };

  const fetchRequirementDetails = async () => {
    if (requirementId) {
      try {
        const response = await api.get(`/buyer/requirements/${requirementId}/`);
        const data = response.data;
        if (data.commodity && typeof data.commodity === "object") {
          data.commodity = data.commodity.id;
        }
        setFormData(response.data);
        setIsEdit(true);
      } catch (error) {
        console.log("Error fetching requirement details:", error);
      }
    }
    setLoading(false);
  };

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container maxWidth="xs" sx={{ mb: 3, marginTop: "20px" }}>
          <div>
            <Grid
              container
              justify="center"
              direction="column"
              style={{ marginTop: "10px" }}
            >
              <CustomTitle>
                {isEdit ? t("Update Requirement") : t("Post a Requirement")}
              </CustomTitle>

              {requirementsBuyer.map((field) => (
                <React.Fragment key={field.name}>
                  {field.type === "text" && (
                    <CustomTextField
                      label={t(field.label)}
                      name={field.name}
                      value={formData[field.name] || ""}
                      onChange={handleChange}
                      type={field.type}
                      error={!!errors[field.name]}
                      helperText={errors[field.name]}
                    />
                  )}

                  {field.type === "select" && field.name === "commodity" && (
                    <CustomTextField
                      label={t(field.label)}
                      name={field.name}
                      value={formData[field.name] || ""}
                      onChange={handleChange}
                      type={field.type}
                      options={commodities.map((commodity) => ({
                        value: commodity.id,
                        label: commodity.name,
                      }))}
                      error={!!errors[field.name]}
                      helperText={errors[field.name]}
                    />
                  )}

                  {field.type === "number" && (
                    <CustomTextField
                      label={t(field.label)}
                      name={field.name}
                      value={formData[field.name] || ""}
                      onChange={handleChange}
                      type={field.type}
                      error={!!errors[field.name]}
                      helperText={errors[field.name]}
                    />
                  )}

                  {field.type === "date" && (
                    <CustomTextField
                      label={t(field.label)}
                      name={field.name}
                      value={formData[field.name] || ""}
                      onChange={handleChange}
                      type={field.type}
                      error={!!errors[field.name]}
                      helperText={errors[field.name]}
                    />
                  )}

                  {field.type === "select" &&
                    field.name === "responder_type" && (
                      <CustomTextField
                        label={t(field.label)}
                        name={field.name}
                        value={formData[field.name] || ""}
                        onChange={handleChange}
                        type={field.type}
                        options={field.options}
                        error={!!errors[field.name]}
                        helperText={errors[field.name]}
                      />
                    )}
                </React.Fragment>
              ))}
              <CustomButton onClick={postRequirement} hideIcon>
                {isEdit ? t("Update") : t("Confirm")}
              </CustomButton>
            </Grid>
          </div>
        </Container>
        {submitting && <SubmittingPopup />}
      </LoaderContainer>
    </>
  );
}
